import Vue from 'vue';
import VueMultianalytics from 'vue-multianalytics';

// Live token: 4bd8b49306d2086944b1767425e4269a
// Dev token: c31795f9676dd23d54a1fa4d8d22c98f
let mpToken = '4bd8b49306d2086944b1767425e4269a';
if (window.location.href.indexOf('localhost:8080') > -1) {
  mpToken = 'c31795f9676dd23d54a1fa4d8d22c98f';
}

const analytics = {
  modules: {
    mixpanel: {
      token: mpToken,
      config: {},
      debug: false
    }
  }
};

Vue.use(VueMultianalytics, analytics);

export default analytics;



// WEBPACK FOOTER //
// ./src/analytics/index.js